import React from "react";
import { Card, Grid } from "@mui/material";
import SearchGlobal from "app/shared/SearchGlobal";

const PagesFiltersToolsBar = ({value, setValue, onSearch, children}) => {
  return (
    <Card
      sx={{
        width: "100%",
        height: "auto",
        padding: 2,
      }}
      elevation={2}
    >
      <Grid container width={"100%"} spacing={2}>
        <Grid item xs={3}>
          <SearchGlobal placeholder={'Pesquisar'} handleSearch={onSearch} value={value} setValue={setValue} />
        </Grid>
        {children}
      </Grid>
    </Card>
  );
};

export default React.memo(PagesFiltersToolsBar);
